import React from 'react';

import './index.scss';

// eslint-disable-next-line react/prop-types
export default function TitleLarge({ children }) {
  return (
    <div className="title-large">{ children }</div>
  );
}
